import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginPageStyles } from '../../../../../styles';
import { Button, Box, CssBaseline, Typography } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { sendOTP, setPhoneNo } from '../../../../../redux/features/User';
import { toast } from 'material-react-toastify';
import OTPVerification from '../ForgotPassword/OTP';
import ChangePassword from '../ChangePassword';
import MuiPhoneNumber from './PhoneNumber/index.js';
import { Toast as CustomToast } from '../../../../../Components';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&.Mui-disabled': {
            opacity: 0.7,
            color: 'white',
          },
        },
      },
    },
  },
});

const textStyle = {
  fontFamily: 'Mulish',
  fontSize: '13px',
  lineHeight: '16px',
};

// const DIGIT_REGEX = /^\+6[0-9]+$/;

export const ForgotPasswordScreen = () => {
  const user = useSelector((state) => state.userReducer.user);
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState({});
  const dispatch = useDispatch();

  const [validatePhoneNumber, setValidatePhoneNumber] = useState(false);
  let navigate = useNavigate();

  // use Effect for handling authorization stuff
  useEffect(() => {
    if (Object.keys(user).length !== 0) {
      navigate('/logistics');
    }
  }, []);

  const classes = loginPageStyles();

  useEffect(() => {
    if (isValidPhoneNumber()) {
      setValidatePhoneNumber(true);
    } else {
      setValidatePhoneNumber(false);
    }
  }, [phoneNumber?.value]);

  const isValidPhoneNumber = () => {
    let country = phoneNumber?.value?.substring(0, 2);
    switch (country) {
      case '60':
        return phoneNumber?.value?.length >= 10;
      case '65':
        return phoneNumber?.value?.length === 10;
      case '62':
        return phoneNumber?.value?.length >= 11;
      default:
        return false;
    }
  };

  const titleStyle = {
    fontSize: '24px',
    lineHeight: '31px',
    fontWeight: '700',
    letterSpacing: '-0.01em',
    color: '#111111',
  };

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Button
            onClick={() => navigate('/login')}
            variant="text"
            sx={{
              minWidth: '0px',
              p: '0px',
              m: '8px',
              ':hover': {
                bgcolor: '#ffffff',
                color: '#000000',
              },
            }}
          >
            <KeyboardArrowLeftIcon sx={{ color: '#8493AE' }} />
          </Button>
        </Box>
        <ThemeProvider theme={theme}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              m: 'auto 26px',
            }}
          >
            {step === 1 && (
              <>
                <Box
                  sx={{ mb: '10px', textAlign: 'center' }}
                  className={classes.heading10}
                  style={titleStyle}
                >
                  Forgot Password?
                </Box>
                <Box sx={{ maxWidth: '323px' }}>
                  <Box
                    className={classes.heading}
                    sx={{
                      textAlign: 'center',
                      mb: '20px',
                      fontSize: '15px',
                      lineHeight: '19px',
                      color: '#111111',
                    }}
                  >
                    Enter your phone number and we will send you an OTP to reset
                    your password.
                  </Box>
                  <Box sx={{ px: '1.5px', mb: '20px' }}>
                    <Box
                      className={classes.heading}
                      sx={{
                        mb: '0.25rem',
                        fontSize: '13px',
                        color: '#455066',
                        lineHeight: '16px',
                      }}
                    >
                      Phone Number
                      <Typography
                        variant="span"
                        sx={{ ml: '2px', color: '#EA4C59' }}
                      >
                        <strong>*</strong>
                      </Typography>
                    </Box>
                    <MuiPhoneNumber
                      onChange={(value, data) => {
                        setPhoneNumber({ ...data, value: value });
                      }}
                    />
                  </Box>
                </Box>
                <Box width="74.31%">
                  <Button
                    onClick={() => {
                      const body = {
                        riders: { contact_number: `+${phoneNumber.value}` },
                      };
                      dispatch(sendOTP(body))
                        .unwrap()
                        .then(() => {
                          setStep(2);
                          dispatch(setPhoneNo(phoneNumber));
                        })
                        .catch((error) => {
                          toast(
                            <CustomToast
                              severity="warning"
                              message={error.message || 'Something went wrong'}
                            />,
                            { closeButton: false }
                          );
                        });
                    }}
                    disabled={!validatePhoneNumber}
                    variant="text"
                    className={classes.buttonStyle}
                    sx={{
                      bgcolor: '#054E8B',
                      py: '4px',
                      ':hover': { bgcolor: '#054E8B' },
                    }}
                    classes={{ disabled: classes.disabledButton }}
                  >
                    Send OTP
                  </Button>
                </Box>
              </>
            )}
            {step === 2 && (
              <OTPVerification
                phoneNumber={phoneNumber.value}
                setStep={setStep}
              />
            )}
            {step === 3 && <ChangePassword />}
          </Box>
        </ThemeProvider>
        <Box style={textStyle} sx={{ color: '#8493AE', mb: '20%' }}>
          Version X.X
        </Box>
      </Box>
    </>
  );
};
export default ForgotPasswordScreen;
